<template>
  <div class="security-question">
    <div class="container">
      <div class="header">
        <el-button type="text" icon="el-icon-arrow-left" @click="$router.go(-1)"
          >返回</el-button
        >
        <span>{{ isExist ? "修改" : "设置" }}密保问题</span>
      </div>
      <div class="main">
        <el-steps :active="activeStep" align-center finish-status="success">
          <el-step
            :title="isExist ? '验证原密保问题' : '填写密保问题'"
          ></el-step>
          <el-step
            :title="isExist ? '设置新密保问题' : '验证密保问题'"
          ></el-step>
          <el-step :title="isExist ? '修改成功' : '设置成功'"></el-step>
        </el-steps>

        <div class="box">
          <div class="set-question" v-if="activeStep == 0">
            <p class="tips">
              {{
                isExist
                  ? "请在下面填写您的原密保答案。"
                  : "为了您的账号安全,请完成以下密保问题设置,以方便您快速找回密码。"
              }}
            </p>
            <div class="questions" v-if="isExist">
              <div
                class="one"
                v-for="(item, idx) in originalQuestions"
                :key="item.id"
              >
                <div style="line-height: 32px">
                  问题{{ idx + 1 }}:
                  <span class="question-text">{{ item.question }}</span>
                </div>
                <div style="padding-left: 8px; margin-top: 10px">
                  答案:
                  <el-input
                    class="answer-input"
                    v-model="item.answer"
                    placeholder="请输入答案"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="questions" v-else>
              <div class="one" v-for="(item, idx) in questions" :key="item.id">
                <div>
                  问题{{ idx + 1 }}:
                  <el-select
                    v-model="item.question"
                    placeholder="请选择密保问题"
                    size="small"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.pqId"
                      :label="item.question"
                      :value="item.pqId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div style="padding-left: 8px; margin-top: 10px">
                  答案:
                  <el-input
                    class="answer-input"
                    v-model="item.answer"
                    placeholder="请输入答案"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="ver-question" v-if="activeStep == 1">
            <p class="tips">
              {{
                isExist
                  ? "请在下面设置您的新密保问题"
                  : "以下是您设置的密保问题,请依次回答,以便确认。"
              }}
            </p>
            <div class="questions" v-if="isExist">
              <div class="one" v-for="(item, idx) in questions" :key="item.id">
                <div>
                  问题{{ idx + 1 }}:
                  <el-select
                    v-model="item.question"
                    placeholder="请选择密保问题"
                    size="small"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.pqId"
                      :label="item.question"
                      :value="item.pqId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div style="padding-left: 8px; margin-top: 10px">
                  答案:
                  <el-input
                    class="answer-input"
                    v-model="item.answer"
                    placeholder="请输入答案"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="questions" v-else>
              <div class="one" v-for="(item, idx) in questions" :key="item.id">
                <div style="line-height: 32px">
                  问题{{ idx + 1 }}:
                  <span class="question-text">{{ check(item.question) }}</span>
                </div>
                <div style="padding-left: 8px; margin-top: 10px">
                  答案:
                  <el-input
                    class="answer-input"
                    v-model="item.userAnswer"
                    placeholder="请输入答案"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="success" v-if="activeStep == 2">
            <i class="el-icon-success"></i>
            <p class="success-tips">
              {{ isExist ? "修改" : "设置" }}成功,请牢记您的密保问题
            </p>
          </div>

          <div class="btns" v-if="activeStep <= 1">
            <el-button
              class="btn"
              type="primary"
              size="medium"
              v-show="activeStep > 0"
              @click="activeStep--"
              >上一步</el-button
            >
            <el-button
              class="btn"
              type="primary"
              size="medium"
              @click="handleNext"
              >{{ activeStep >= 1 ? "提交" : "下一步" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sQuestionList,
  saveQuestion,
  myQuestion,
  verQuestion,
  editQuestion,
} from "@/api/securityQuestion";
export default {
  data() {
    return {
      activeStep: 0,
      originalQuestions: [],
      questions: [
        { id: 1, question: "", answer: "", userAnswer: "" },
        { id: 2, question: "", answer: "", userAnswer: "" },
        { id: 3, question: "", answer: "", userAnswer: "" },
      ],
      options: [],
    };
  },
  created() {
    this.getQuestions();
    if (this.isExist) this.getMyQuestion();
  },
  computed: {
    isExist() {
      return this.$store.state.myInfo.passwordQuestion;
    },
  },
  methods: {
    // 密保问题列表
    getQuestions() {
      sQuestionList().then(({ code, data, msg }) => {
        if (code == 0) {
          this.options = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 我的密保问题
    getMyQuestion() {
      this.$loading.show();
      myQuestion().then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.originalQuestions = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    check(pqId) {
      let o = this.options.find((item) => {
        return item.pqId == pqId;
      });
      return o.question;
    },
    handleNext() {
      if (this.isExist) {
        // 修改
        if (this.activeStep < 1) {
          this.$loading.show();
          verQuestion(this.originalQuestions).then(({ code, data, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              if (data) this.activeStep++;
              else this.$message.error("题目回答有误");
            } else {
              this.$message.error(msg);
            }
          });
        } else {
          let ver = this.questions.every((item) => {
            return item.question && item.answer;
          });
          if (ver) {
            this.questions.map((item) => {
              item.pqId = item.question;
            });
            this.$loading.show();
            editQuestion(this.questions).then(({ code, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.activeStep++;
              } else {
                this.$message.error(msg);
              }
            });
          } else this.$message.warning("请选择问题并填写答案");
        }
      } else {
        // 设置
        if (this.activeStep < 1) {
          let ver = this.questions.every((item) => {
            return item.question && item.answer;
          });
          if (ver) this.activeStep++;
          else this.$message.warning("请选择问题并填写答案");
        } else {
          let pass = this.questions.every((item) => {
            return item.answer == item.userAnswer;
          });
          if (pass) {
            this.questions.map((item) => {
              item.pqId = item.question;
            });
            this.$loading.show();
            saveQuestion(this.questions).then(({ code, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.activeStep++;
                this.$store.dispatch("getUserInfo");
              } else {
                this.$message.error(msg);
              }
            });
          } else {
            this.$message.error("题目回答有误");
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.security-question {
  background-color: rgb(248, 248, 248);
  .header {
    margin-top: 20px;
    padding: 16px 30px;
    border-radius: 4px;
    background-color: #fff;
    text-align: left;
    span {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .main {
    margin: 20px 30px;
    padding: 30px 0;
    background-color: #fff;
    .box {
      margin-top: 30px;
      padding: 0 160px;
      .set-question,
      .ver-question {
        .tips {
          font-weight: bold;
          text-align: left;
        }
        .questions {
          margin-top: 30px;
          .one {
            margin-bottom: 30px;
            .question-text {
              display: inline-block;
              width: 215px;
              text-align: left;
            }
            .answer-input {
              width: 215px;
            }
          }
        }
      }
      .success {
        padding: 125px 0 155px;
        .el-icon-success,
        .success-tips {
          color: teal;
          &.el-icon-success {
            font-size: 70px;
          }
          &.success-tips {
            margin-top: 30px;
            font-size: 26px;
            font-weight: bold;
          }
        }
      }

      .btns {
        margin-top: 55px;
      }
    }
  }
}
</style>